// extracted by mini-css-extract-plugin
export default {"register":"Register_register__3l8Dp","register_container":"Register_register_container__t+RA6","register_form":"Register_register_form__S-c2v"};